import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import ServiceAreas from '../components/ServiceAreas';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import QuoteTeaser from '../components/QuoteTeaser';

const Home = () => {
    return (
        <>
            <Hero />
            <Services />
            <WhyUs />
            <ServiceAreas />
            <Process />
            <Testimonials />
            <QuoteTeaser />
        </>
    );
};

export default Home;
